<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/contract-icon.svg" alt="Historial de etapas" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Historial de contratos</h1>
                    </div>
                    <div class="header-actions">
                            <img src="assets/svg/reloadd-icon.svg" alt="Exportar" width="31" height="32"/>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>8 elementos | Se actualizó hace 5 minutos | Ordenado por última modificación</span>
                </div>
                <div class="content-area mt-5">
                    <div class="prospectos-table mh-50">
                        <table>
                            <thead>
                                <tr>
                                    <th class="checkbox-column text-center">
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Fecha
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Cambio realizado
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Usuario
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Valor anterior
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Valor actualizado
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="checkbox-column">
                                        <h4>1.</h4>
                                    </td>
                       <td>29/09/2025 18:45</td>
                      <td>Estado</td>
                      <td>Juan Soto</td>
                      <td>Borrador</td>
                      <td>En proceso de aprobación</td>
                                </tr>
                                <tr>
                                    <td class="checkbox-column">
                                        <h4>2.</h4>
                                    </td>
                      <td>29/09/2025 16:20</td>
                      <td>Creado</td>
                      <td>Juan Soto</td>
                      <td></td>
                      <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>